import type { SVGProps } from 'react';
import * as React from 'react';

const DataBookIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
    <g id="product-logo/data-book">
      <path
        id="Vector"
        d="M13.2153 7.1108V18.764C13.2153 19.4379 12.6701 19.9756 12.0038 19.9756C11.3299 19.9756 10.7923 19.4304 10.7923 18.764V9.63226C10.7923 8.77663 9.87607 8.22388 9.11888 8.63276L1.59992 12.6686C1.2289 12.8655 1.00174 13.2517 1.00174 13.6681V21.3158C1.00174 21.9443 1.50906 22.4516 2.13753 22.4516H21.8625C22.491 22.4516 22.9983 21.9443 22.9983 21.3234C22.9983 17.7721 22.9983 7.55755 22.9983 3.13552C22.9983 2.27989 22.0896 1.73471 21.3324 2.13602L13.8211 6.1113C13.45 6.30817 13.2153 6.69434 13.2153 7.11837V7.1108Z"
        fill="#494949"
      />
      <g id="Group">
        <g id="Clip path group">
          <mask id="mask0_7184_140" maskUnits="userSpaceOnUse" x={1} y={2} width={22} height={21}>
            <g id="clippath">
              <path
                id="Vector_2"
                d="M13.2153 7.1108V18.764C13.2153 19.4379 12.6701 19.9756 12.0038 19.9756C11.3299 19.9756 10.7923 19.4304 10.7923 18.764V9.63226C10.7923 8.77663 9.87607 8.22388 9.11888 8.63276L1.59992 12.6686C1.2289 12.8655 1.00174 13.2517 1.00174 13.6681V21.3158C1.00174 21.9443 1.50906 22.4516 2.13753 22.4516H21.8625C22.491 22.4516 22.9983 21.9443 22.9983 21.3234C22.9983 17.7721 22.9983 7.55755 22.9983 3.13552C22.9983 2.27989 22.0896 1.73471 21.3324 2.13602L13.8211 6.1113C13.45 6.30817 13.2153 6.69434 13.2153 7.11837V7.1108Z"
                fill="white"
              />
            </g>
          </mask>
          <g mask="url(#mask0_7184_140)">
            <g id="Group_2">
              <g id="Vector_3" opacity={0.5}>
                <path
                  d="M10.7922 22.9437H0.236938V7.7392H10.7922V21.5202C10.7922 22.0123 11.1557 22.4061 11.6024 22.4061H12.2158L10.7998 22.9437H10.7922Z"
                  fill="#494949"
                />
              </g>
              <g id="Vector_4" opacity={0.5}>
                <path
                  d="M10.7999 21.6717V12.0553L13.2153 11.4117L13.2683 21.6187C13.2683 22.073 12.9049 22.4365 12.4506 22.4365H11.5722C11.1482 22.4365 10.7999 22.0957 10.7999 21.6641V21.6717Z"
                  fill="#494949"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);
export default DataBookIcon;
